import { render } from "./VPageContent.vue?vue&type=template&id=14ed396d&ts=true"
import script from "./VPageContent.vue?vue&type=script&lang=ts"
export * from "./VPageContent.vue?vue&type=script&lang=ts"

import "./VPageContent.vue?vue&type=style&index=0&id=14ed396d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__